import { IsEmail, IsNotEmpty, IsString } from 'class-validator'

export class ManageCampaignAdminFormState {
  @IsString()
  @IsEmail()
  @IsNotEmpty({ message: 'Email must not be empty' })
  email: string
}
